import { AppShell } from "@/shared/layouts/AppShell.jsx";
import { UsersManager } from "./UsersManager.jsx";
import { CLINIC_ROLE_OPTIONS } from "@/shared/lib/roles.js";

/** Usuários e permissões da clínica. */
export function UsersPage() {
  return (
    <AppShell title="Usuários e Permissões" subtitle="Equipe com acesso ao sistema da clínica">
      <UsersManager escopo="clinic" roleOptions={CLINIC_ROLE_OPTIONS} />
    </AppShell>
  );
}
